<template>
  <div>
    <div class="crm-top cases-top">
      <div class="cases-top-left">
        <div class="case-tabs">
          <router-link to="/osobe">
            <div class="case-tab case-tab-osobe">{{ $t('persons_page.persons_tab.t1') }}</div>
          </router-link>
          <router-link to="/institucije">
            <div class="case-tab case-tab-institucije active">{{ $t('persons_page.persons_tab.t2') }}</div>
          </router-link>
        </div>
      </div>
      <div class="cases-top-right">
        <div to="/nova-osoba" class="add-case" @click="openNewInstitution">
          {{ $t('persons_page.new_institut') }}
          <div class="add-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
            >
              <g>
                <g>
                  <path
                    fill="#fff"
                    d="M10.346 7.733H7.741v2.606a1.737 1.737 0 1 1-3.474 0V7.733H1.662a1.737 1.737 0 0 1 0-3.476h2.605V1.651a1.737 1.737 0 1 1 3.474 0v2.606h2.605a1.737 1.737 0 0 1 0 3.476z"
                  />
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
      <div class="crm-line">
        <div class="letter-search">
          <div
            :class="slovo_pretrazivanja == 'Sve' ? 'ls active' : 'ls'"
            @click="slovo_pretrazivanja = 'Sve'"
          >
            <div class="inner-ls" @click="tableAnim">{{ $t('persons_page.all') }}</div>
          </div>
          <div
            :class="slovo == slovo_pretrazivanja ? 'ls active' : 'ls'"
            v-for="(slovo, idx) in slova"
            :key="idx"
            @click="slovo_pretrazivanja = slovo"
          >
            <div class="inner-ls" @click="tableAnim">{{ slovo }}</div>
          </div>
        </div>
        
        <!-- <div class="crm-dropdown">
          Prikaz:
          <select id="search-group">
            <option value="sve">Prikaži sve</option>
            <option value="ugovor">Način plaćanja: Ugovor</option>
            <option value="tarifa">Način plaćanja: Tarifa</option>
            <option value="ove-godine">Datum upisa: Ove godine</option>
            <option value="posljednji-mjesec">
              Datum upisa: Posljednji mjesec
            </option>
            <option value="privatna-osoba">Privatna osoba</option>
            <option value="pravna-osoba">Pravna osoba</option>
          </select>
          <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
        </div> -->
      </div>
    </div>
    <div class="testtable">
      <div v-if="fetching" class="paznja-spinner">
        <svg class="dot-spin" viewBox="0 0 50 50">
          <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
        </svg>
      </div>
      <table v-else class="responstable">
        <tr>
          <th>{{ $t('persons_page.institucije.h1') }}<div class="downarrow"></div></th>
          <th data-th="Detalji institucije"><span>{{ $t('persons_page.institucije.h2') }}</span><div class="downarrow"></div></th>
          <th>{{ $t('persons_page.institucije.h3') }}<div class="downarrow"></div></th>
          <th>{{ $t('persons_page.institucije.h4') }}<div class="downarrow"></div></th>
          <th>{{ $t('persons_page.institucije.h5') }}<div class="downarrow"></div></th>
        </tr>
        
        <tr v-for="(inst, key) in finalni_arr_prikaza" :key="key">
          <td>
            <router-link :to="'/osobe/institucije/' + inst.uid">{{
              inst.naziv
            }}</router-link>
          </td>
          <td>
            <div v-if="inst.adresa != null && inst.adresa.length > 0">
              {{ inst.adresa[0].adresa + ', ' }}{{ inst.adresa[0].post_br + ', ' }}
              {{ inst.adresa[0].grad + ', ' }}{{inst.adresa[0].drzava}}
            </div>
            <v-tooltip
              right
              v-if="inst.adresa != null && inst.adresa.length > 1"
            >
              <template v-slot:activator="{ on, attrs }">
                <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">
                  Right
                </v-btn> -->
                <img
                  v-bind="attrs"
                  v-on="on"
                  class="more-dots"
                  src="@/assets/img/more.svg"
                />
              </template>
              <p v-for="(adresa, key) in inst.adresa" :key="key">
                {{ adresa.adresa + ', ' }}{{adresa.post_br + ', ' }}
                {{ adresa.grad + ', ' }}{{adresa.drzava}}
              </p>
            </v-tooltip>
          </td>
          <td>
            {{ inst.oib }}
          </td>
          <td>
            <router-link
              v-if="inst.spis.length > 0"
              :to="'/case/' + inst.spis[inst.spis.length-1].predmet.group_url + '/'"
              >{{ inst.spis[inst.spis.length-1].predmet.ime_predmeta }}</router-link
            >
            <v-tooltip
                right
                v-if="inst.spis.length > 1"
              >
                <template v-slot:activator="{ on, attrs }">
                  <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Right
                  </v-btn> -->
                  <img
                    v-bind="attrs"
                    v-on="on"
                    class="more-dots"
                    src="@/assets/img/more.svg"
                  />
                </template>
                <p v-for="(predmet, key) in inst.spis" :key="key">
                  {{ predmet.predmet.ime_predmeta }}
                </p>
              </v-tooltip>
          </td>
          <td>
            <div v-if="inst.tel_br_list.length > 0">
              {{ inst.tel_br_list[0] }}
            </div>
            <v-tooltip
                right
                v-if="inst.tel_br_list.length > 1"
              >
                <template v-slot:activator="{ on, attrs }">
                  <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Right
                  </v-btn> -->
                  <img
                    v-bind="attrs"
                    v-on="on"
                    class="more-dots"
                    src="@/assets/img/more.svg"
                  />
                </template>
                <p
                  v-for="(tel, key) in inst.tel_br_list"
                  :key="key"
                  >{{ tel }}</p
                >
            </v-tooltip>
          </td>
        </tr>
      </table>
    </div>


    <div class="cases-pagination">
      <Pagination ref="paginat" :finalni_arr_prikaza.sync="finalni_arr_prikaza" :br_redova="br_redova" :ukupna_lista="ukupna_lista"/>
      <div class="cases-pagination-right">
        {{ $t("page_2.row_count") }}
        <div class="broj-redova">
          <select class="drop-filter" id="search-group" v-model="br_redova">
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
          </select>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="7"
            height="11"
            viewBox="0 0 7 11"
          >
            <g>
              <g>
                <path
                  fill="#3326ae"
                  d="M.204 3.503a.754.754 0 0 0 .572.264c.18 0 .354-.065.506-.196l1.816-1.828L4.92 3.571c.142.142.33.22.53.22.202 0 .39-.078.533-.22a.76.76 0 0 0 0-1.065L3.632.14A.748.748 0 0 0 3.1-.077c-.2 0-.388.077-.53.22L.203 2.522a.754.754 0 0 0 0 .98z"
                />
              </g>
              <g>
                <path
                  fill="#3326ae"
                  d="M6.026 7.411a.758.758 0 0 0-1.083-.067L3.12 9.17 1.291 7.343a.75.75 0 0 0-.532-.22.75.75 0 0 0-.534.221.757.757 0 0 0 0 1.065l2.36 2.364a.752.752 0 0 0 .533.219c.201 0 .39-.078.534-.22l2.374-2.38a.752.752 0 0 0 0-.98z"
                />
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from "@/services/auth";
import moment from "moment";
import institucije from "@/apiCallers/promise_handler_db/institucije";
import gsap from "gsap";
import Pagination from "@/components/generalComponents/Pagination.vue";
import { handlePageLoad, storeQueryParams } from "@/router/queryHandler/index"

export default {
  components:{ Pagination },
  data() {
    return {
      slovo_pretrazivanja: "",

      br_redova: 5,
      accessToken: "",
      all_institucije: [],
      br_redova: 5,
      fetching: true,
      slova: [],
      inputFizVis: false,
      ukupna_lista: [],
      finalni_arr_prikaza: [],
      activate_filters: false,
      queryParams: undefined
    };
  },
  async created() {
        this.queryParams = handlePageLoad("institutions");

    this.accessToken = this.$store.state.aToken 
    institucije.getAllInstitucije().then((resp) => {
      resp.data.forEach((p) => {
        if (!this.slova.includes(p.naziv.substring(0, 1).toUpperCase())) {
          this.slova.push(p.naziv.substring(0, 1).toUpperCase());
        }
        this.all_institucije.push(p);
      });

      // this.all_institucije.sort((a, b) => (a.naziv > b.naziv && 1) || -1);
      this.all_institucije.sort((a, b) => (a.naziv.toUpperCase().localeCompare(b.naziv.toUpperCase(),'hr', { sensitivity: 'base' })) );
      this.slova.sort((a, b) => a.localeCompare(b, 'hr', { sensitivity: 'base' }));

       if (this.queryParams != null && this.queryParams != undefined && !this.activate_filters) {
          this.assignParamValues()
        }
      this.filterPersons();
      this.fetching = false
    });
  },
  watch: {
    slovo_pretrazivanja: function () {
      if (this.activate_filters) {
      this.$refs.paginat.curr_page = 1;
      this.filterPersons();
      }
    },
    br_redova: function(){
      if (this.activate_filters)
      this.filterPersons();
    },
     finalni_arr_prikaza: function () {
      if (this.activate_filters) {
        this.queryParams = storeQueryParams("institutions", {
          curr_page: this.$refs.paginat.curr_page,
          slovo_pretrazivanja: this.slovo_pretrazivanja,
          br_redova: this.br_redova,
        });
      } else {
        this.activate_filters = true;
      }
    },
  },
  methods: {
    assignParamValues: function () {
      this.$refs.paginat.curr_page = this.queryParams.curr_page,
        this.slovo_pretrazivanja = this.queryParams.slovo_pretrazivanja,
        this.br_redova = this.queryParams.br_redova
    },
    openNewInstitution(){
      this.$store.state.vrsta_osobe = 3;
      this.$router.push("/nova-osoba");

    },
    getPosljednjiPredmet(popis_pred) {
      if (popis_pred == null || popis_pred == undefined) {
        return "";
      }
      var lista_predmeta = popis_pred.split(",");
      if (lista_predmeta.length > 0) {
        return lista_predmeta[0];
      } else return popis_pred;
    },
    getPosljednjiLink(popis_link) {
      // console.log(popis_link)
      if (popis_link == undefined) {
        return "";
      }
      var url_list = popis_link.split(",");
      if (url_list.length > 0) {
        return url_list[0];
      } else return popis_link;
    },
    filterPersons() {
      var tmp_array = this.all_institucije.slice();
      this.queryParams = storeQueryParams("institutions", {
          curr_page: this.$refs.paginat.curr_page,
          slovo_pretrazivanja: this.slovo_pretrazivanja,
          br_redova: this.br_redova,
        });

      //filter by letter
      if (this.slovo_pretrazivanja != "Sve") {
        if (this.slovo_pretrazivanja != "") {
        tmp_array = tmp_array.filter((p) => {
            return p.naziv.substring(0, 1).toUpperCase() == this.slovo_pretrazivanja;
        });
      } else {
        if (this.slova.length > 0) {
          this.slovo_pretrazivanja = 'Sve';
          tmp_array = tmp_array.filter((p) => {
            return p.naziv.substring(0, 1) == this.slova[0];
          });
        }
      }
      }
      
      this.ukupna_lista = tmp_array;
      var finalni_broj = this.ukupna_lista.length / this.br_redova;
      this.$refs.paginat.all_pages = [];
      if (this.ukupna_lista.length % this.br_redova >= 1) {
        finalni_broj++;
      }
      for (var i = 1; i <= finalni_broj; i++) {
        this.$refs.paginat.all_pages.push(i);
      }
      setTimeout(() => {
        this.$refs.paginat.paginirajOdabrane();
      }, 50);
    },
    switchDate(inData) {
      if (inData == "-" || inData == null) {
        return "-";
      } else {
        return moment(inData.toString()).format("l");
      }
    },
    fullLogout() {
      auth.clearLocal();
      auth.logout();
      this.$router.push({ path: "/login" });
    },
    tableAnim() {
      gsap.fromTo(
        ".responstable",
        0.4,
        { x: -10, opacity: 0 },
        { x: 0, opacity: 1 }
      );
    },
  },
  mounted() {
    // body class
    document.body.classList.add("osobe-institucije");
  },
  destroyed() {
    document.body.classList.remove("osobe-institucije");
  },
};
</script>

<style>
</style>